import { UserInterface } from 'src/app/@core/interfaces/user.interface';
import { ErrorInterface } from '../../../@core/interfaces/general.interface';

export interface ClientUserState {
  entity: UserInterface | null;
  error: boolean | ErrorInterface;
  loading: boolean;
  update: boolean;
}

export const initialClientUserState: ClientUserState = {
  entity: null,
  error: false,
  loading: false,
  update: false,
};
